module.exports = __webpack_public_path__ + "img/Frente-56-01 on.4ac53a8d.png";